import React from 'react';
import PropTypes from 'prop-types';
import Image from '../styled/Image';

function LeaderboardList({ leaderboards }) {
  return (
    <div className="leaderboard-list">
      <div className="leaderboard-list__title">
        <h1>Leaderboards</h1>
      </div>
      <div className="leaderboard-list__table">
        <table>
          <thead>
            <tr>
              <th colSpan={2}>User</th>
              <th>Score</th>
            </tr>
          </thead>
          <tbody>
            {leaderboards.map((leaderboard) => (
              <tr key={leaderboard.user.id}>
                <td>
                  <Image width="32px" height="32px" className="leaderboard-list__table-image" src={leaderboard.user.avatar} alt={leaderboard.user.name} />
                </td>
                <td className="table-column-wide">
                  {leaderboard.user.name}
                </td>
                <td>
                  {leaderboard.score}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const userShape = {
  id: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  avatar: PropTypes.string,
};

const leaderboardShape = {
  score: PropTypes.number.isRequired,
  user: PropTypes.shape(userShape).isRequired,
};

LeaderboardList.propTypes = {
  leaderboards: PropTypes.arrayOf(PropTypes.shape(leaderboardShape)).isRequired,
};

export default LeaderboardList;
